module.exports = "uniform vec4 resolution;\r\nvarying vec2 vUv;\r\nvoid main()\t{\r\n\tgl_FragColor = vec4(1.0, vUv, 1.0);\r\n}"